import { get, post, publicSiteUrl } from './request'
import { getStore, keys } from '../store'
import { toQueryLang } from '../utils/locale'
import axios from 'axios'
/**
 *
 * @param {String} mobile
 * @param {String} password
 * @param {String} country_code
 * @returns {Promise<
 *  {
 *      token: String
 *      country_code: String
 *      email: String
 *      invite_code: String
 *      last_student_avatar: String
 *      last_student_nickname: String
 *      last_student_sn: String
 *      mobile: String
 *      nickname: String
 *      referer_code: String
 *      status: Number
 *      token: String
 *      user_sn: String
 * }>}
 */
export function login(mobile, password, country_code) {
    return post('/api/signin', { mobile, password, country_code })
}

/**
 *
 * @returns {Promise<Array<{ kinds:Number }>>}
 */
export function getKidsTypeList() {
    return get('/api/getChildFormShow')
}

/**
 * @param  {Number} kids 孩子的数量
 * @returns {Promise<{
 *      "kid_type": Number,
 *      "title": String,
 *      "remarks": String,
 *      "describe": String",
 *      "price": String,
 *      "discount": null,
 *      "plan_details": String[],
 *      "color": String
 * }>}
 */
export function getPlanList(kids,user_sn) {
    return get(`/api/getProjectItem?kids=${kids}&user_sn=${user_sn}`)
}

/**
 *
 * @returns {Promise<{
 *      price: String
 *      quantity: Number
 * }>}
 */
export function getCreatPlanList(user_sn) {
    return get(`/api/getAddProjectItem?user_sn=${user_sn}`)
}

/**
 *
 * @returns {Promise<{
 *      title: String
 *      content: String
 * }>}
 */
export function getFaqList() {
    return get('/api/getAnswerItem')
}

/**
 *
 * @returns
 */
export function getUserInfo() {
    return get('/api/getMemberMess')
}
/**
 *
 */
export function getHidePlanList(){
    return get('/api/getMaskProjectItem')
}
/**
 *
 */
export function getBillingHistoryList(pageIndex, pageSize = '') {
    return get(`/api/getCostRecordItem?page=${pageIndex}&pagesize=${pageSize}`)
}

export function getChargesList(pageIndex, pageSize = '') {
    return get(`/api/getFeesItem?page=${pageIndex}&pagesize=${pageSize}`)
}

/**
 *
 * @param {string} plan_id
 * @returns
 */
export function buyMember(plan_id) {
    return post('/api/purchaseVip', { plan_id })
}

/**
 *
 * @param {string} good_id
 * @returns
 */
export function buyCredit(good_id) {
    return post('/api/purchasePoint', { good_id })
}

/**
 *
 * @param {{
 * order_no: String
 * username: String
 * mobile: String
 * email: String
 * pay_method: String
 * }} data
 * @returns {}
 */
export function confirmOrder(data) {
    return post('/api/checkOrder', data)
}

/**
 *
 * @param {{
 * order_no: String
 * payment_method_nonce: String
 * }} data
 * @returns {}
 */
export function creatBrainTreeOrder(data) {
    return post('/api/addMindNodeBill', data)
}

/**
 *
 * @param {String} order_no 订单号
 * @param {String} type
 * @returns {Promise<{
 *      sessionId: String,
 *      url:String
 *  }>
 * }
 */
export function stripePayment(order_no, type) {
    return post('/api/settleTrade', { order_no, type })
}

/**
 * 发送验证码
 * @param {*} mobile
 * @param {*} country_code
 * @returns
 */
export function verifyCode(mobile, country_code) {
    return post('/api/signin/checkCode', { mobile, country_code, length: 6 })
}
/**
 * 检测手机号
 * @param {*} mobile
 * @param {*} country_code
 * @returns
 */
 export function checkUser(mobile, country_code) {
    return post('/api/reviewMember', { mobile, country_code})
}
/**
 * 短信验证码登录
 * @param {*} mobile
 * @param {*} verifyCode
 * @param {*} country_code
 * @returns {{
 *  id:String
 *  user_sn:String
 *  model:String
 *  first_name:String
 *  last_name:String
 *  name:String
 *  nickname:String
 *  mobile:String
 *  email:String
 *  gender:String
 *  avatar:String
 *  motto:String
 *  open_id:String
 *  unique_id:String
 *  last_login_time:String
 *  created_at:String
 *  updated_at:String
 *  stopped_at:String
 *  country_code:String
 *  province:String
 *  city:String
 *  district:String
 *  invite_code:String
 *  token:String
 *  last_student_sn:String
 *  last_student_nickname:String
 *  last_student_avatar:String
 *  is_register:String  true:新用户注册 false:老用户
 * }}
 */
export function verifyCodeLogin(mobile, verifyCode, country_code,time_zone) {
    return post('/api/checkCodeSignin', { mobile, code: verifyCode, country_code,time_zone })
}
/**
 * 账号密码登录
 * @param {*} mobile
 * @param {*} password
 * @param {*} country_code
 * @returns {{
 *  is_register:String  true:新用户注册 false:老用户
 * }}
 */
export function passLogin(mobile, password, country_code,time_zone) {
    return post('/api/signin', { mobile, password, country_code,time_zone })
}

/**
 *
 * @param {*} full_name 姓名
 * @param {*} email 邮箱
 * @param {*} wechat_id 微信号
 * @returns
 */
export function setUserProfile(full_name, email, wechat_id) {
    return post('/api/saveMemberInfo', { full_name, email, wechat_id })
}

/**
 * 选择国家或地区
 */
export function getCountries({ page = 1, pageSize = 999, keywords = null, country_code = null }) {
    return get('/api/base/country', { page, pageSize, keywords, country_code })
}

/**
 * 点击记录
 * @param {*} type 1 进入首页  2 注册成功  3 订单页
 * @param {*} user_sn 用户sn
 */
export function recordClick(type, user_sn, value) {
    return post('/api/createScoreLog', { type, user_sn, value })
}

/**
 *
 * @param {String} mobile
 * @param {String} name
 * @param {String} country_code
 * @param {String} email
 * @returns {Promise<
*  {
    *      country_code: String
    *      email: String
    *      mobile: String
    *      name: String
    *      wechat_id: String
    * }>}
*/
export function joinUser(form) {
    return post('/api/enlistMember',form)
}
/**
 *
 */
 export function getPayOrderDetail() {
    return get('/api/getBuyTicketRecord')
}

export function getIntercomUser(time_zone) {
    return get(`/api/chatMember?time_zone=${time_zone}`)
}
/**
 * 获取销售卡片信息
 */
 export function getSaleInfo(invite_code) {
    return get('/api/getDealData?invite_code='+invite_code)
}


/**
 * 获取协议
 */
export function getAgreement(type) {
  return get('/api/getAgreement?type=' + type)
}

/**
 * 公共信息（顶部导航 / 友情链接 / 页脚）
 * @param {string} [lang] zh_CN / en，默认取当前语言
 */
export function getPublicInfo(lang) {
  const queryLang = lang != null ? ( String(lang) == 'en' ? 2 : 1) : toQueryLang()
  console.log(queryLang,'queryLang');
  
  return get(`${publicSiteUrl}/api/publicInfo?lang=${queryLang}`)
}

/**
 * 留资表单提交
 * @param {{
 *  studentName: string
 *  parentPhone: string
 *  email: string
 *  wechatId?: string
 *  interestedCourse: string
 *  lang?: string
 * }} form
 */
export function submitStudentInfo(form) {
  const params = new URLSearchParams()
  params.append('studentName', (form.studentName || '').trim())
  params.append('parentPhone', (form.parentPhone || '').trim())
  params.append('email', (form.email || '').trim())
  params.append('wechatId', (form.wechatId || '').trim())
  params.append('interestedCourse', (form.interestedCourse || '').trim())
  params.append('lang', form.lang || 'zh-CN')

  return axios({
    url: `${publicSiteUrl}/studentInfo`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    data: params.toString(),
  }).then((res) => res.data)
}

export function resolvePublicAssetUrl(path) {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  return publicSiteUrl + path
}



// WEBPACK FOOTER //
// ./src/api/index.js